import { NumberValueAccessor } from '@angular/forms';
import { DadosSeparacao } from './dados-separacao';
import { DadosSeparacaoTransporte } from './dados-separacao-tranporte';
import { AcaoAcompanhamento } from './enum';

export class EtapaPedido {
  id: number;
  idCupom: string;
  idEtapa: number;
  dataHora: Date;
  usuario: number;
  acao?: AcaoAcompanhamento;
  justificativa: string;
  notaFiscal: string;
  volume: number;
  dimensao: string;
  peso: number;
  codErp: string;
  dadosSeparacao: DadosSeparacao;
  dadosSeparacaoTransporte: DadosSeparacaoTransporte;
}
